<rwidget-schedule-planner (onPlannerSearch)="handleSearch()"></rwidget-schedule-planner>
